var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yoyo-container mx-auto min-h-screen" },
    [
      _c("navBar", { attrs: { title: _vm.$t("mine.myCoupons") } }),
      _c(
        "div",
        { staticClass: "lg:mx-4 lg:w-[calc(100%-2rem)]" },
        [
          _c(
            "van-tabs",
            {
              attrs: { sticky: "" },
              on: { click: _vm.onTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "van-tab",
                { attrs: { title: _vm.$t("coupons.available"), name: "1" } },
                [
                  _c(
                    "div",
                    { staticClass: "mt-4 mx-4" },
                    [
                      _vm._l(_vm.coupons, function (coupon) {
                        return _c("coupon-card", {
                          key: coupon.id,
                          attrs: { coupon: coupon, status: "available" },
                        })
                      }),
                      _vm.coupons.length === 0
                        ? _c(
                            "div",
                            { staticClass: "text-center py-8" },
                            [
                              _c("van-empty", {
                                attrs: {
                                  description: _vm.$t("coupons.noAvailable"),
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _c(
                "van-tab",
                { attrs: { title: _vm.$t("coupons.used"), name: "2" } },
                [
                  _c(
                    "div",
                    { staticClass: "mt-4 mx-4" },
                    [
                      _vm._l(_vm.coupons, function (coupon) {
                        return _c("coupon-card", {
                          key: coupon.id,
                          attrs: { coupon: coupon, status: "used" },
                        })
                      }),
                      _vm.coupons.length === 0
                        ? _c(
                            "div",
                            { staticClass: "text-center py-8" },
                            [
                              _c("van-empty", {
                                attrs: {
                                  description: _vm.$t("coupons.noUsed"),
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _c(
                "van-tab",
                { attrs: { title: _vm.$t("coupons.expired"), name: "3" } },
                [
                  _c(
                    "div",
                    { staticClass: "mt-4 mx-4" },
                    [
                      _vm._l(_vm.coupons, function (coupon) {
                        return _c("coupon-card", {
                          key: coupon.id,
                          attrs: { coupon: coupon, status: "expired" },
                        })
                      }),
                      _vm.coupons.length === 0
                        ? _c(
                            "div",
                            { staticClass: "text-center py-8" },
                            [
                              _c("van-empty", {
                                attrs: {
                                  description: _vm.$t("coupons.noExpired"),
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }